type OffScreenListener = (isOffScreen: boolean) => void;

const listeners = new WeakMap<Element, OffScreenListener>();
let observer: IntersectionObserver | undefined;

const getObserver = () => {
    observer ??= new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            listeners.get(entry.target)?.(!entry.isIntersecting);
        });
    });
    return observer;
};

/**
 * Reports when `element` leaves or re-enters the viewport, clipping by
 * scrolling ancestors included. One observer serves every caller, so a board
 * full of pills adds a single observer. Returns the unsubscribe.
 */
export const observeOffScreen = (
    element: Element,
    listener: OffScreenListener,
) => {
    if (typeof IntersectionObserver === "undefined") {
        return () => {};
    }
    listeners.set(element, listener);
    getObserver().observe(element);
    return () => {
        listeners.delete(element);
        getObserver().unobserve(element);
    };
};
